import React, {Component} from 'react';
import './affiliate-program.scss';

export default class AffiliateProgram extends Component {
    render() {
        const url = pda_gold_v3_data.pda_v3_plugin_url + "public/assets/pda-gold-affiliate-banner-v5.png";
        return (
                <div>
                    <a className="pda-affiliate-program-img" target="_blank" href="http://bit.ly/joinpdaffiliatenow">
                        <img src={url}/>
                    </a>
                </div>
        );
    }

}